import "./QASection.css";

import React, { useState, useEffect } from "react";
import Footer from "../../Footer";
import { useNavigate } from "react-router-dom";

const qaDataAmazon = [
  {
    id: "step",
    header: "아마존 킨들 출판 대행 기본 이해"
  },
  {
    id: "q1",
    question: "아마존 킨들 출간이란 무엇인가요?",
    answer: `아마존 킨들 다이렉트 퍼블리싱(KDP)을 통해 전 세계 독자들에게 전자책을 판매하는 서비스입니다. 190개국 이상에서 판매가 가능하며, 세계 최대 전자책 시장에 진출할 수 있습니다.`
  },
  {
    id: "q2",
    question: "아마존 킨들 출판 대행의 장점은 무엇인가요?",
    answer: `• 글로벌 시장: 전 세계 190개국 독자 접근
            • 높은 수익률: 로열티 최대 70%
            • 빠른 출간: 승인 후 24-72시간 내 판매 시작
            • 무료 출간: 초기 비용 없음 (대행 서비스 제외)
            • 실시간 관리: 가격, 내용 수정 즉시 반영`
  },
  {
    id: "q3",
    question: "어떤 책이 아마존 킨들 출판 대행에 적합한가요?",
    answer: `• 영어 원고: 영어로 작성된 책 (필수)
            • 범용적 주제: 전 세계 독자가 관심 가질 만한 내용
            • 전문서적: IT, 비즈니스, 자기계발, 건강 등
            • 소설: 로맨스, 판타지, 미스터리 등 인기 장르
            • 실용서: 요리, 여행, 취미 관련 도서`
  },
  {
    id: "q4",
    question: "한국어 책도 출간할 수 있나요?",
    answer: `네, 한국어 원서 그대로 출간 가능합니다.
            
            K-드라마·K-팝·K-푸드의 글로벌 열풍으로
            한국어 원서에 대한 해외 독자 관심이 높아지고 있습니다.
            번역으로는 담기 어려운 순우리말의 감성을
            전 세계 독자에게 그대로 전달해 드립니다.
            (text → 이미지 변환)

            글로벌 시장 확대를 원하신다면
            한·영 동시 출간도 가능합니다. 지금 무료 상담을 받아보세요.`
  },
  {
    id: "q6",
    question: "에이콘출판과 크몽을 통한 출판 대행의 차이점?",
    answer: `에이콘출판은 작가님의 편의를 위해 다음 두 채널을 통해 서비스를 제공합니다.
            혼선 방지를 위해, 반드시 하나의 채널(에이콘온 웹사이트 또는 크몽)에서만 견적 요청 부탁드립니다.`,
    table: `
    |  구분  | 에이콘출판 웹사이트 신청 | 크몽 신청 |
    | --- | --- | --- |
    |  문의 방법  | 이메일, 카카오톡,전화 등  | 크몽 사이트에서 문의(계약 후 연락처 제공 가능) |
    | 계약 및 비용 지불 | 계약금 50%, 출간 후 잔금 50% (사후관리비 선택) | 크몽 제휴 결제 및 승인 |
    | 수수료 구조  | 출간대행 비용만 청구(중간 플랫폼 수수료 없음) | 크몽 플랫폼 수수료 포함(비용 상승 가능성 있음) |
    |  가격 협의  | 맞춤 견적 협의 가능 | 가격 협의 범위 제한 있음 |
    |  추천 대상  | 장기 출판,여러 권 출판 계획 작가님  | 1회성, 단편 출판 계획 작가님 |
    `
  },
  {
    id: "step",
    header: "비용 및 서비스"
  },
  {
    id: "q7",
    question: "아마존 킨들 출판 대행 비용은 얼마인가요?",
    answer: `
              베이직 패키지(전자책 단독): ₩1,350,000

              •  KDP 계정 및 Tax Profile 최적화 설정
              •  전자책 내지 제작 (Word → KDP 전용 규격 최적화)
              •  전자책 표지 제작 (KDP 템플릿 시안 3개, 수정 1회)
              •  메타데이터 / 키워드(7개) / 카테고리(3개) / 도서 소개 최적화
              •  Kindle Previewer 품질 최종 검수
              •  글로벌 출간 및 유통 등록
              •  Author Central 구축 가이드 PDF 제공
              •  수정 1회 · 30일 사후 지원

              프로 패키지(전자책 + 종이책(POD) + 마케팅): ₩3,400,000
              
              • Basic 전체 포함
              • 종이책 내지 제작 (6×9 기준)
              • 종이책 커스텀 표지 디자인 (Spine 포함, 시안 2개, 수정 1회)
              •  Author Central + SEO / AMS Ads 초기 설정
                (최적 운영 마케팅 가이드 패키지 PDF 제공)
              •  수정 2회 · 60일 사후 지원
                
              ※ 영문 2만 단어 / 이미지·도표 5개 이내 기준 ※ 번역·광고 별도 ※ 모든 금액은 VAT(10%) 별도
            `
  },
  {
    id: "q8",
    question: "월 관리비가 있나요?",
    answer: `네, 월 3만 원의 관리비가 있으며 저작자가 전액 부담합니다. 
            이는 다음 서비스를 위한 비용이며, 선택사항입니다: 
            
            • 판매 현황 모니터링 :  실시간 판매 데이터 제공 
            • 수익 정산 관리    :   아마존 로열티 정산 및 환전 
            • 마케팅 지원       :  키워드 최적화 및 프로모션 관리
            • 기술 지원         :  아마존 정책 변경 대응 및 업데이트
            • 저자 포털         :  전용 대시보드를 통한 통합 관리
            `
  },
  {
    id: "q9",
    question: "번역 비용은 별도인가요?",
    answer: `네, 별도 옵션으로 선택 가능합니다. 
            
            • 한→영, 한→일 그외 언어 한글 1자당
              분야별 전문 번역가 | 분야별 전문 번역가를 배정하여 진행하고 있습니다. 
            
            ※ Basic/Pro + 번역 동시 진행 시 최대 10% 할인
            `
  },
  {
    id: "q10",
    question: "추가 서비스 비용은?",
    answer: ` `,
    table:`
    | 서비스 | 비용 | 내용 |
    | --- | --- | --- |
    | 초과 원고 | 4만5천 원/천자 | 기본 영문 2만 단어 초과 시 1,000단어 당 |
    | 시각 자료 추가 | 1~2만 원/1개 | 기본 5개 초과 시 해상도/블리드 최적화 포함 |
    | 종이책 변환(POD) | 150만 원 | POD 인쇄용 변환/글로벌 출간 및 유통 등록 (6×9 흑백 기준) |
    | 표지 커스텀 디자인(Spine 포함) | 75만 원 | 전문 디자이너 커스텀 표지 (시안 2개 + 수정 1회) |
    | 하드커버 출간 | 85만 원 | Pro패키지 진행 시(표지 하드커버 규격 재설계 + 유통 대행) |
    | 원어민 검수(C1 이상) | 100만 원 | 영문  2만 단어 기준/ 번역 동시 진행 시 할인 적용 |
    | Author Central + SEO/AMS Ads 초기 설정 + 마케팅 가이드 패키지(PDF)| 50만 원 | 키워드 리서치/캠페인 초기 세팅/AMS 운영 가이드 PDF 단,광고비(CPC) 별도 · 성과 미보증 |
    | 초기 노출 & 리뷰 확보 | 100만 원 | AMS 정책 맞춤 서평단 모집/배포 3~5건 |    
    `
  },
  {
    id: "q11",
    question: "결제 방식은?",
    answer: `
      1. 계약금: 총액의 50% (계약 시) 
      2. 잔금: 총액의 50% (출간 완료 시) 
      3. 월 관리비: 매월 3만 원 (출간 후/선택사항) `
  },
  {
    id: "step",
    header: "번역 및 편집"
  },
  {
    id: "q12",
    question: "번역 품질은 어떻게 보장하나요?",
    answer: `기본 패키지:

• 1차 번역: 분야별 전문 번역가
• 2차 검수: 자체 편집팀 검토
• 3차 확인: 저작자 최종 승인
• 무료 수정: 3회까지 무료 수정

프리미엄 패키지:

• 기본 패키지 모든 과정 포함
• 원어민 검수: CEFR C1 이상 수준
• 고급 편집: 문체 및 표현 고도화`
  },
  {
    id: "q13",
    question: "번역자를 지정할 수 있나요?",
    answer: `네, 가능합니다:

• 이력 제공: 번역자 경력 및 전문 분야 안내
• 샘플 번역: 2-3페이지 샘플 번역 제공
• 저작자 선택: 최종 번역자 선택권은 저작자
• 추가 비용: 특급 번역자 지정 시 20% 추가`
  },
  {
    id: "q14",
    question: "번역 기간은 얼마나 걸리나요?",
    answer: ` `,
    table:`
    | 분량 | 번역 기간 | 검수 기간 | 총 기간 |
    | --- | --- | --- | --- |
    | 5만자 이하 | 2주 | 1주 | 3주 |
    | 10만자 이하 | 4주 | 2주 | 6주 |
    | 15만자 이하 | 6주 | 2주 | 8주 |
    | 20만자 이상 | 별도 협의 | 별도 협의 | 협의 |`
  },
  {
    id: "q15",
    question: "원고에 문제가 있으면?",
    answer: `
• 사전 검토: 번역 전 원고 품질 검토
• 문제 지적: 구체적인 개선사항 제안
• 수정 요청: 저작자에게 수정 요청
• 협의 진행: 번역 가능한 수준까지 협의`
  },
  {
    id: "q16",
    question: "저작자가 영어를 할 수 있다면?",
    answer: `• 검토 서비스: 번역 과정 참여 가능
• 직접 수정: 저작자 직접 수정 허용
• 협업 번역: 번역자와 저작자 협업
• 비용 할인: 저작자 참여도에 따른 할인 (최대 30%)`

  },
  {
    id: "step",
    header: "킨들 포맷 및 기술"
  },
  {
    id: "q17",
    question: "킨들 포맷이란 무엇인가요?",
    answer: `아마존 킨들에서 읽을 수 있도록 최적화된 전자책 포맷입니다:

• MOBI/AZW3: 킨들 전용 포맷
• 반응형 디자인: 다양한 기기에서 최적 표시
• 목차 연결: 클릭 가능한 목차
• 검색 기능: 텍스트 검색 최적화`
  },
  {
    id: "q18",
    question: "한국 전자책과 차이점은?",
    answer: ``,
    table:`
    | 항목 | 한국 전자책 | 킨들 |
    | --- | --- | --- |
    | 포맷 | EPUB | MOBI/AZW3 |
    | 폰트 | 한국어 폰트 | 영문 폰트 |
    | 레이아웃 | 고정형 가능 | 주로 리플로우 |
    | 이미지 | 고해상도 | 최적화 필요 |
    | 목차 | 기본 | 고급 내비게이션 |`
  },
  {
    id: "q19",
    question: "이미지나 표가 많은 책은?",
    answer: `• 이미지 최적화 : 킨들 최적 해상도로 변환 
            • 표 변환 : 킨들 친화적 이미지로 재구성 
            • 레이아웃 조정 : 다양한 기기에서 잘 보이도록 조정  `
  },
  {
    id: "q20",
    question: "업로드 과정은?",
    answer: 
        `1. 파일 준비: 최종 원고 및 표지
        2. 메타데이터: 제목, 저자, 카테고리, 키워드
        3. 가격 설정: 지역별 가격 설정
        4. 세무 정보: 저작자 세무 정보 등록
        5. 최종 검토: 아마존 심사 (24-72시간)`
  },
  {
    id: "q21",
    question: "수정이 필요하면?",
    answer: 
      `
      • Basic  수정 1회 · 30일 사후 지원
      • Pro    수정 2회 · 60일 사후 지원
      • 이후 추가 수정 시 별도 비용 발생
        (KDP 품질 검사 수정 ₩100,000/회)
      `
  },
  {
    id: "step",
    header: "마케팅 및 최적화"
  },
  {
    id: "q22",
    question: "아마존 마케팅은 어떻게 하나요?",
    answer: 
      `• 키워드 최적화: 검색에 유리한 키워드 설정
      • 카테고리 선택: 적절한 베스트셀러 카테고리
      • 설명 최적화: 매력적인 책 소개글 작성
      • 가격 전략: 경쟁력 있는 가격 설정
      • 프로모션: 무료/할인 이벤트 기획`
  },
  {
    id: "q23",
    question: "KDP Select가 무엇인가요?",
    answer: `
            KDP Select는 90일간 아마존 독점 배포 조건으로
            아래 혜택을 제공합니다. 

            • Kindle Unlimited 포함 (구독자 무제한 열람)
            • Kindle Countdown Deals (기간 할인 프로모션)
            • Free Book Promotion (무료 배포 이벤트)
            • 70% 로열티 ($2.99~$9.99 가격대)
          `
  },
  {
    id: "q24",
    question: "AMS 광고란?",
    answer: `아마존 내부 광고 시스템:

      • 키워드 광고: 검색 결과 상단 노출
      • 상품 광고: 관련 도서 페이지 노출
      • 브랜드 광고: 저자/출판사 브랜딩
      • 비용: 클릭당 과금 (CPC)
      • 관리: 전문가가 대신 관리`
  },
  {
    id: "q25",
    question: "리뷰 관리는?",
    answer: 
      `• 자연적 리뷰: 독자들의 자연스러운 리뷰 유도 
      • 리뷰 모니터링: 실시간 리뷰 확인 및 분석 
      • 품질 개선: 부정 리뷰 분석을 통한 개선 방안 제시 
      • 리뷰 증대: 합법적인 리뷰 증대 전략 제공 
      • 전문 리뷰: 별도 서비스 (100만 원~)
      `
  },
  {
    id: "q26",
    question: "베스트셀러 달성 전략은?",
    answer: 
      `1. 출시 타이밍: 최적의 출시 시기 선택
      2. 가격 전략: 런칭 할인 → 정가 전환
      3. 무료 프로모션: KDP Select 무료 이벤트
      4. 집중 마케팅: 출시 1주일 집중 홍보
      5. 모멘텀 유지: 지속적인 마케팅 활동`
  },
  {
    id: "step",
    header: "수익 및 정산"
  },
  {
    id: "q27",
    question: "아마존 로열티는 어떻게 되나요?",
    answer: ``,
    table:`
    | 가격대 | 로열티율 | 조건 |
    | --- | --- | --- |
    | $0.99-$2.98 | 35% | 기본 |
    | $2.99-$9.99 | 70% | KDP Select 권장 |
    | $10.00 이상 | 35% | 고가 도서 |`
  },
  {
    id: "q28",
    question: "정산은 어떻게 이루어지나요?",
    answer: 
      `• 아마존 정산 기준 : 매월 말일
      • 지급일 : 익월 말 (약 60일 후)
      • 지급 통화 : USD (달러)
      • 수령 방법 : Payoneer 또는 외화 계좌 직접 수령
      • 환전 : 저자 직접 환전 (환율·수수료 저자 부담)`
  },
  {
    id: "q29",
    question: "최소 지급 기준은?",
    answer: 
      `수령 방법에 따라 기준이 다릅니다.

      EFT (Direct Deposit · Payoneer 포함)
      → 최소 금액 없음 (threshold 없음)
      → 매월 자동 지급
      → 입금까지 1~5 영업일
      → 에이콘온 권장 방법

      Wire Transfer (전신송금)
      → 최소 $100 이상 누적 시 지급
      → 미달 시 다음 달로 이월 누적
      → 입금까지 5~10 영업일
      → 은행 수수료 별도 발생
        (수수료 금액은 거래 은행마다 상이)

      Check (수표)
      → 최소 $100 이상 누적 시 발송
      → 수표 수령까지 최대 30일 소요
      → 한국에서는 사용 불편 (권장 안 함)

      공통
      → 지급 기준일: 매월 말일 판매분
      → 실제 지급일: 60일 후
        (예: 1월 판매분 → 3월 말 지급)

      ※ 에이콘 대행 서비스를 이용하시면 원하시는 방법으로 계정 설정을 도와드립니다.
      `
  },
  {
    id: "q30",
    question: "세금 처리는?",
    answer:
      `1. 미국 세금:

        •  W-8BEN 양식 제출 시 원천징수 면제 또는 감액 (한·미 조세조약 적용) 
        •  에이콘온이 W-8BEN 등록 대행

        2. 한국 세금:

        • KDP 수익은 기타소득으로 신고
        • 연 300만원 이상 시 종합소득세 신고 필요
        • 세무 신고는 저자 본인 책임
          (에이콘온은 세무 조언을 제공하지 않음)


        * 정산 계정 관련 안내
        기존에 보유하신 페이오니아(Payoneer) 계정이 있다면 해당 계정으로 정산 연결을 진행해 드립니다.
        단, 페이오니아 신규 계정 가입 및 인증 절차는 대행 범위에서 제외(별도 진행)됩니다.
      `
  },
  {
    id: "q31",
    question: "수익 추적은?",
    answer: `저자 포털 사이트를 통해 실시간 확인:

      • 일별 판매량: 실시간 판매 현황
      • 수익 계산: 로열티 자동 계산
      • 순위 추적: 카테고리별 순위 변동
      • 지역별 분석: 국가별 판매 현황`
  },
  {
    id: "step",
    header: "글로벌 판매 및 확장"
  },
  {
    id: "q32",
    question: "어느 나라에서 판매되나요?",
    answer: `아마존이 서비스하는 190개국:

      • 주요 시장: 미국, 영국, 독일, 프랑스, 일본, 캐나다
      • 성장 시장: 인도, 브라질, 멕시코, 호주
      • 아시아: 싱가포르, 홍콩 등
      • 수익 분포: 보통 미국 60-70%, 기타 30-40%`
  },
  {
    id: "q33",
    question: "지역별 마케팅이 다른가요?",
    answer: `네, 지역별 특성을 고려한 마케팅:

      • 미국: 경쟁 치열, 프로모션 중요
      • 영국: 품질 중시, 리뷰 중요
      • 독일: 상세한 설명 선호
      • 일본: 표지 디자인 중요
      • 인도: 가격 민감성 높음`
  },
  {
    id: "q34",
    question: "다국어 번역도 가능한가요?",
    answer: ` 네, 현재 아래 언어 번역 서비스를 제공합니다.
              
              • 한→영 번역  ₩60~220 / 한글 1자
              • 한→일 번역  ₩90~120 / 한글 1자

              그 외 언어(독일어·프랑스어·스페인어 등)는
              시장성 검토 후 별도 협의 가능합니다.
              → 무료 상담 신청

              ※ 번역 단가는 원고 난이도·분량에 따라 달라질 수 있으며
                정확한 금액은 상담 후 확정됩니다.`
  },
  {
    id: "q35",
    question: "POD(인쇄형 도서)도 가능한가요?",
    answer: `네, 아마존 POD 서비스 이용 가능합니다. 
            
            • 추가 비용 : 150만 원(내지 조판 비용|표지 제작 별도) 
            • 인쇄 품질 : 아마존 표준 품질
            • 배송 : 전 세계 배송 가능
            • 재고 없음 : 주문 시 인쇄 방식`
  },
  {
    id: "q36",
    question: "다른 플랫폼 동시 출간은?",
    answer: `

• KDP Select 기간: 90일간 아마존 독점
• 기간 후: Apple Books, Google Play 등 가능
• 추가 서비스: 다른 플랫폼 출간 대행 (별도 비용)
• 전략: 아마존 먼저 → 성과 확인 후 확장`
  },
  {
    id: "step",
    header: "사후 관리 및 지원"
  },
  {
    id: "q37",
    question: "출간 후 지원 서비스는?",
    answer: ` 저자 포털 사이트를 통한 종합 관리:

• 실시간 모니터링: 판매량, 순위, 수익 현황
• 마케팅 지원: 키워드 최적화, 프로모션 관리
• 기술 지원: 아마존 정책 변경 대응
• 분석 리포트: 월간 성과 분석 리포트
• 고객 지원: 1:1 상담 및 기술 지원`
  },
  {
    id: "q38",
    question: "아마존 정책 변경 시 대응은?",
    answer: `

• 모니터링: 아마존 정책 변경 사항 추적
• 즉시 알림: 저작자에게 영향도 분석 및 알림
• 대응 방안: 구체적인 대응 방안 제시
• 무료 수정: 정책 변경으로 인한 수정 무료 지원`
  },
  {
    id: "q39",
    question: "계속 판매가 부진하면?",
    answer: `

• 원인 분석: 판매 부진 요인 상세 분석
• 개선 방안: 구체적인 개선 전략 제시
• 마케팅 강화: 추가 마케팅 투자 (별도 비용)
• 콘텐츠 개선: 내용 수정 및 업데이트 지원`
  },
  {
    id: "q40",
    question: "계약 기간은?",
    answer: `

• 기본 계약: 2년
• 자동 연장: 별도 통보 없으면 1년씩 자동 연장
• 중도 해지: 6개월 전 서면 통보
• 해지 후: 저작자가 모든 권리 회수`
  },
  {
    id: "q41",
    question: "평균 수익은?",
    answer: `

• 평균 월 판매: 50 ~ 200부 (장르별 차이)
• 평균 월 수익: $100 ~ 500 (13 ~ 65만 원)
• 수익 범위: 장르와 마케팅 정도에 따라 편차 큼
• 손익분기점: 보통 6-18개월
• 장기 수익: 지속적인 관리 시 안정적 수익 가능`
  },
  {
    id: "step",
    header: "성공 전략 및 팁"
  },
  {
    id: "q42",
    question: "아마존 킨들 출판 대행 성공의 핵심은?",
    answer: `

1. 품질: 전문적인 번역과 편집
2. 마케팅: 지속적인 키워드 최적화
3. 타이밍: 적절한 출시 시기
4. 가격: 경쟁력 있는 가격 전략
5. 인내: 장기적 관점의 마케팅`
  },
  {
    id: "q43",
    question: "장르별 성공 확률은?",
    answer: ``,
table:`
| 장르 | 성공 확률 | 평균 수익 | 특징 |
| --- | --- | --- | --- |
| 자기계발 | 높음 | $300-800 | 꾸준한 수요 |
| 비즈니스 | 높음 | $200-600 | B2B 독자층 |
| 건강/피트니스 | 중간 | $150-400 | 시즌성 있음 |
| 소설 | 낮음 | $50-300 | 경쟁 치열 |
| 요리/취미 | 중간 | $100-300 | 이미지 중요 |`
  },
  {
    id: "q44",
    question: "실패 요인과 예방법은?",
    answer: `
    
주요 실패 요인:
• 번역 품질 문제
• 부적절한 카테고리 선택
• 마케팅 부족
• 경쟁 과열 장르 선택

예방법:
• 전문 번역 서비스 이용
• 철저한 시장 조사
• 지속적인 마케팅 투자
• 틈새 시장 공략`
  },
  {
    id: "q45",
    question: "추가 투자가 필요한 경우는?",
    answer: `

• 마케팅: 월 50 ~ 100만 원 AMS 광고
• 리뷰: 전문 리뷰 서비스 80만 원
• 표지 개선: 현지화 표지 디자인 50만 원
• 오디오북: 300만 원 (높은 수익률)`
  },
  {
    id: "q46",
    question: "장기적 성공 전략은?",
    answer: `

1. 시리즈화: 연관 도서 지속 출간
2. 브랜딩: 저자 브랜드 구축
3. 독자층 구축: 이메일 리스트 구축
4. 다양화: 여러 장르 도전
5. 현지화: 지역별 맞춤 전략

`
  },
  {
    id: "step",
    header: "상담 및 신청"
  },
  {
    id: "q47",
    question: "상담은 어떻게 받나요?",
    answer: `• 무료 상담: 원고 및 시장성 검토
• 상담 방식: 전화, 화상, 방문 상담
• 준비물: 완성된 원고, 저자 이력
• 소요 시간: 1-2시간 상세 상담`
  },
  {
    id: "q48",
    question: "계약 전 확인사항은?",
    answer: `

• 번역 품질 및 기간
• 마케팅 지원 범위
• 사후 관리 서비스
• 월 관리비 및 추가 비용
• 수익 정산 방식
• 계약 기간 및 해지 조건`
  },
  {
    id: "q49",
    question: "성공 가능성 사전 평가는?",
    answer: `무료 사전 평가 서비스:
            • 원고 장르·분량 기준 패키지 추천
            •  영문 원고 기준 기초 품질 검토
              (영문 2만 단어 이내 무료 제공)
            • 아마존 카테고리 및 경쟁 도서 기초 안내
            •  예상 비용 견적 안내 

            📧 연락처
            • 전화: 02-2653-7600
            • 이메일: acornpub@acornpub.co.kr
            • 주소: (07547) 서울시 강서구 양천로 583, A-2009호
            • 상담 시간: 평일 09:00-18:00
`
  },
];


const StepHeader = ({ header }) => (
  <div className="qa-step-header">
    <h4>{header}</h4>
  </div>
);


const QAItem = ({ id, question, answer, table, isOpen, onToggle }) => {
  const renderAnswer = () => {
    const answerContent = answer && (
      <p style={{ whiteSpace: "pre-line", marginBottom: table ? "1rem" : 0 }}>
        {answer}
      </p>
    );

    if (table) {      
      const lines = table.trim().split("\n");    
      const rows = lines
        .filter(line => line.trimStart().startsWith("|"))
        .map(line =>  
          line
            .trimStart()      
            .split("|")
            .slice(1, -1)
            .map(cell => cell.trim())
        );

      const [header, , ...body] = rows;

      return (
        <>
          {answerContent}
          <table className="qa-table">
            <thead>
              <tr>
                {header.map((cell, idx) => (
                  <th key={idx}>{cell}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {body.map((row, rIdx) => (
                <tr key={rIdx}>
                  {row.map((cell, cIdx) => (
                    <td key={cIdx}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </>
      );
    } else {
      return answerContent;
    }
  };


  return (
    <div className={`qa-card ${isOpen ? "open" : ""}`}>
      <div
        className="qa-card-question-header"
        onClick={() => onToggle(id)}
        role="button"
        aria-expanded={isOpen}
        aria-controls={`qa-answer-${id}`}
        tabIndex="0"
      >
        <h3>{question}</h3>
        <img
          src="./images/arrow-down.png"
          alt="Toggle dropdown"
          className="qa-card-arrow"
        />
      </div>
      <div
        id={`qa-answer-${id}`}
        className="qa-card-answer"
        aria-hidden={!isOpen}
      >
        {renderAnswer()}
      </div>
    </div>
  );
};


const QAAmazon = () => {
  const navigate = useNavigate();
  const [openFAQId, setOpenFAQId] = useState(null);

  const handleToggleFAQ = (id) => {
    setOpenFAQId((prevId) => (prevId === id ? null : id));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="qa-section-container">
        <div className="qa-section">          
          <div className="qa-section-header" >
            <button
              onClick={() => {
                navigate("/", { state: { scrollToFAQ: true } }); // 돌아갈 때 flag 전달
              }}
              className="carousel-nav-button prev"
              aria-label="Previous slide"
            >
              ❮
            </button>
            <h2>아마존 킨들 출판 대행 FAQ</h2>
          </div>
          <div className="qa-cards-container">
            {qaDataAmazon.map((qa, index) => {
              if (qa.id === "step") {
                return <StepHeader key={`step-${index}`} header={qa.header} />;
              }
              return (
                <QAItem
                  key={qa.id}
                  id={qa.id}
                  question={qa.question}
                  answer={qa.answer}
                  table={qa.table}
                  isOpen={openFAQId === qa.id}
                  onToggle={handleToggleFAQ}
                />
              );
            })}
          </div>           
        </div>      
      </section>
      <Footer />
    </div>
  );
};

export default QAAmazon;
